export class Telefone {
  public ddd: string;
  public numero: string;
  public idCategoria: string;
  public idCategoriaTelefone: string;
  public idTipoTelefone: string;

  constructor(ddd?: string, numero?: string, idCategoria?: string, idTipoTelefone?: string, idCategoriaTelefone?: string) {
    this.ddd = ddd;
    this.numero = numero;
    this.idCategoria = idCategoria;
    this.idTipoTelefone = idTipoTelefone;
    this.idCategoriaTelefone = idCategoriaTelefone;
  }
}
